// ----------------------------------------------------------------------
// <copyright file="Izenda.ConnectionConfig.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * @module ConnectionConfig component
 * @example
 *   <ConnectionConfig>
 *     <Header></Header>
 *     <ConnectionDetail>
 *       <ConnectionBuilderModal></ConnectionBuilderModal>
 *     </ConnectionDetail>
 *     <ConnectButton></ConnectButton>
 *     <DataSourceTree></DataSourceTree>
 *   </ConnectionConfig>
 */
!(function() {
  var constants = require('logic/data/Izenda.ConnectionConstants');
  var React = require('react');
  var Header = require('./Header/Izenda.Header');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var ConnectionDetail = require('./ConnectionDetail/Izenda.ConnectionDetail');
  var ConnectButton = require('./ConnectButton/Izenda.ConnectButton');
  var DataSourceTreeContainer = require('./DataSourceTree/Izenda.DataSourceTreeContainer');
  var commonMessages = require('share/messages/Izenda.CommonMessages');
  var MESSAGE_TYPE = commonMessages.MESSAGE_TYPE;
  var connect = require('share/enhancers/Izenda.Connect');
  const { isEmpty } = require('lodash/fp');
  var getConnectLabel = function(connectionDetail) {
    /*
     * Just display 'Reconnect' when (AND operator):
     *   - Editing Connection
     *   - DataSource of Tree does not empty
     *   - Connection String does not change
     */
    return connectionDetail.needReloadDetectChange ? constants.CONNECT_TYPE.RECONNECT : constants.CONNECT_TYPE.CONNECT;
  };

  var ConnectionConfig = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired,
      dbTypeList: React.PropTypes.object.isRequired
    },
    componentDidMount: function() {
      this.props.store.init();
    },
    componentWillUnmount: function() {
      this.props.store.destroy();
    },
    componentWillReceiveProps: function(nextProps) {
      if (this.props.item !== nextProps.item) {
        this.props.validation.reset();
        this.props.item.setAlertMessage(commonMessages.EMPTY_MESSAGE);
      }
    },
    render: function() {
      // Connection detail store
      var store = this.props.store;
      var item = this.props.item;
      var disabled = !item.isConnectionStringReady;

      var connectBtnLabel = getConnectLabel(this.props.item);

      return (
        <div className='izenda-TableLayout-Cell'>
          <section className='izenda-Wrapper'>
            <Header
              ref='Header'
              onCancel={this.onCancel}
              onSave={this.onSave}
              disabled={!item.visible}
              alertMessage={item.alertMessage}
              onResetAlert={this.resetAlertMessage}
            />

            <div className='izenda-Wrapper-content'>
              <ScrollBox>
                <div className='u_fullHeight u_paddingLeftRight'>
                  <ConnectionDetail {...this.props} onTestConnection={this.onTestConnection} />

                  <ConnectButton
                    onConnectButtonClick={this.onConnectToDataSource}
                    connectBtnLabel={connectBtnLabel}
                    disabled={disabled}
                  />

                  <DataSourceTreeContainer
                    store={store}
                    disabled={disabled}
                    item={item}
                    isAddNew={isEmpty(this.props.item.id)}
                  />
                </div>
              </ScrollBox>
            </div>
          </section>
        </div>
      );
    },

    /**
     * Retrieve connection detail and update via API.
     */
    onSave: function() {
      var props = this.props;
      var store = props.store;
      var loader = props.loader;
      var validationManager = props.validation;
      var item = props.item;
      var localization = props.localization;

      validate.call(this);

      function validate() {
        var confirmFn = props.confirmFn;
        var confirmMessage = props.confirmMessage;

        loader.startLoading();
        this.onTestConnection()
          .then(function(validateSchemaStatus) {
            item.setAlertMessage(commonMessages.EMPTY_MESSAGE);

            if (!item.canSave) {
              item.setAlertMessage({
                type: MESSAGE_TYPE.INFO,
                messages: commonMessages.SUPP_MSG_028
              });
              return;
            }

            if (item.canSave && validateSchemaStatus) {
              return confirmFn('Confirmation', {
                description: item.needConfirmMessageForAvailableDatasouceChange
                  ? constants.M05
                  : localization.getText('COMMON_MESSAGES_CONFIRM_SAVE')
              }).then(function() {
                return store.save();
              });
            } else if (!validateSchemaStatus) {
              confirmMessage('error', constants.MISMATCH_CONNECIONSTRING_DATASOURCE);
            }
            return null;
          })
          .then(function(saveErrors) {
            if (!isEmpty(saveErrors)) {
              validationManager.updateErrors(saveErrors);
            }
            return null;
          })
          .finally(loader.endLoading.bind(loader));
      }
    },

    /**
     * Cancel changes that user made for connection.
     */
    onCancel: function() {
      var store = this.props.store;
      var item = store.item;
      var validationManager = this.props.validation;
      var localization = this.props.localization;

      if (item.isDirty) {
        this.props
          .confirmFn('Confirmation', {
            description: localization.getText('COMMON_MESSAGES_CONFIRM_CHANGES_LOST')
          })
          .then(function() {
            validationManager.reset();
            return store.load(item.id);
          });
      } else {
        item.setAlertMessage({
          type: MESSAGE_TYPE.INFO,
          messages: commonMessages.SUPP_MSG_028
        });
      }
    },
    /**
     * Test input connection string associated with database server type.
     */
    onTestConnection: function() {
      var store = this.props.store;
      var loader = this.props.loader;
      var confirmMessage = this.props.confirmMessage;

      var item = this.props.item;
      var valManager = this.props.validation;

      loader.startLoading();
      return valManager
        .validate('connectionString')
        .then(function(success) {
          if (success) {
            store.populateDatabaseName();
            return success;
          } else if (!item.isNew) {
            return confirmMessage('info', constants.REVERSE_CONNECTION_STRING).then(function() {
              valManager.reset('connectionString');
              store.load(item.id);
              return null;
            });
          }
          return Promise.reject();
        })
        .then(function(validationStatus) {
          if (item.isCurrentConnectionStringSameAsSavedConnectionString) {
            return validationStatus;
          } else {
            return store.validateSchema();
          }
        })
        .finally(loader.endLoading.bind(loader));
    },

    /**
     * Connect to data source by its current connection string
     */
    onConnectToDataSource: function() {
      // Set force:true to enforce loading new data source from API
      var store = this.props.store;
      var loader = this.props.loader;
      var item = store.item;

      if (!item.isConnectionStringReady) {
        return;
      }
      var connectToDataSource = item.isCurrentConnectionStringSameAsSavedConnectionString
        ? store.connectToDataSource(item, true)
        : this.props
            .confirmFn('Confirmation', {
              description: constants.NEW_CONNECTIONSTRING_DIFFERENT_SCHEMA
            })
            .then(store.connectToDataSource.bind(store, item, true));

      loader.startLoading();

      function onReconnectComplete() {
        if (!item.canSave) {
          item.markDirty();
        }
      }

      return connectToDataSource.finally(onReconnectComplete.bind(this)).then(loader.endLoading.bind(loader));
    },

    resetAlertMessage: function() {
      var store = this.props.store;
      var item = store.item;
      item.setAlertMessage(commonMessages.EMPTY_MESSAGE);
    }
  });

  module.exports = connect()(ConnectionConfig);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/ConnectionConfig/Izenda.ConnectionConfig.jsx